import React from "react";

export const ContainerFilms = ({ movies, children }) => {
  return <div className="container-films-user">{children}</div>;
};

export default ContainerFilms;
